import { render, staticRenderFns } from "./modalRecompensas.vue?vue&type=template&id=333c4c68&scoped=true&"
import script from "./modalRecompensas.vue?vue&type=script&lang=js&"
export * from "./modalRecompensas.vue?vue&type=script&lang=js&"
import style0 from "./modalRecompensas.vue?vue&type=style&index=0&id=333c4c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c4c68",
  null
  
)

export default component.exports